import React, { createContext, useEffect, useReducer } from "react";

export const themeContext = createContext();

const getInitialDarkMode = () => {
  if (typeof window === "undefined") return false;
  const saved = window.localStorage.getItem("portfolio-theme");
  if (saved === "dark") return true;
  if (saved === "light") return false;
  return window.matchMedia("(prefers-color-scheme: dark)").matches;
};

const themeReducer = (state, action) => {
  switch (action.type) {
    case "toggle":
      return { darkMode: !state.darkMode };
    case "set":
      return { darkMode: Boolean(action.payload) };
    default:
      return state;
  }
};

export const ThemeProvider = (props) => {
  const [state, dispatch] = useReducer(themeReducer, undefined, () => ({
    darkMode: getInitialDarkMode(),
  }));

  useEffect(() => {
    const root = document.documentElement;
    root.classList.toggle("dark", state.darkMode);
    root.style.colorScheme = state.darkMode ? "dark" : "light";
    window.localStorage.setItem(
      "portfolio-theme",
      state.darkMode ? "dark" : "light"
    );
  }, [state.darkMode]);

  return (
    <themeContext.Provider value={{ state, dispatch }}>
      {props.children}
    </themeContext.Provider>
  );
};
